import React, { useCallback, useContext, useEffect, useState, createContext } from 'react';
import ReactDOM from 'react-dom';

// Umožňuje CustomModalInline vnútri (viď hoc/customModalInline.js) oznámiť najbližšiemu
// fullscreen modalu, že je nad ním otvorený vnorený panel. Fullscreen modal vtedy schová
// svoje vlastné tlačidlo na zatvorenie (aby neboli vedľa seba dva krížiky) a ignoruje ESC -
// o zatvorenie sa postará panel sám (viď capture-fázový handler v customModalInline.js).
const FullscreenModalContext = createContext(null);

export const useInnerPanelOpen = (isOpen) => {
    const ctx = useContext(FullscreenModalContext);
    useEffect(() => {
        if (!ctx || !isOpen) return;
        ctx.registerInnerPanel();
        return () => ctx.unregisterInnerPanel();
    }, [ctx, isOpen]);
};

const CustomModalFullscreen = ({ isVisible, onClose, children }) => {
    // Počítadlo namiesto boolean-u, aby to fungovalo správne aj keby bol (teoreticky) otvorený
    // viac než jeden vnorený panel naraz.
    const [openPanelCount, setOpenPanelCount] = useState(0);
    const hasOpenInnerPanel = openPanelCount > 0;

    const registerInnerPanel = useCallback(() => {
        setOpenPanelCount((count) => count + 1);
    }, []);

    const unregisterInnerPanel = useCallback(() => {
        setOpenPanelCount((count) => Math.max(0, count - 1));
    }, []);

    useEffect(() => {
        const handleEscKey = (e) => {
            if (e.key === 'Escape' && !hasOpenInnerPanel) {
                onClose();
            }
        };

        document.addEventListener('keydown', handleEscKey);

        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, [onClose, hasOpenInnerPanel]);

    return ReactDOM.createPortal(
        <>
            {/* Overlay */}
            <div
                className={`custom-modal-overlay ${isVisible ? 'visible' : ''}`}
                onClick={onClose}
            ></div>

            {/* Modal */}
            <div className={`custom-modal-fullscreen ${isVisible ? 'visible' : ''}`}>
                <div className="custom-modal-fullscreen-content">
                    {!hasOpenInnerPanel && (
                        <button className="close-button" onClick={onClose}>×</button>
                    )}
                    <FullscreenModalContext.Provider value={{ registerInnerPanel, unregisterInnerPanel }}>
                        {children}
                    </FullscreenModalContext.Provider>
                </div>
            </div>
        </>,
        document.body // Modal sa umiestni priamo do koreňa dokumentu
    );
};

export default CustomModalFullscreen;
